<template>
  <v-form
      ref="modifyEmpForm"
      @submit.prevent=""
      class="fill-height of-y"
      :disabled="loading"
  >
    <div class="">
      <div class="d-flex align-center primary pl-3 pr-2">
        <div class="flex-grow-1 sub--text">
          {{ employee.id ? 'Edit Employee' : 'Create Employee' }}
        </div>
        <div v-if="!employee.id">
          <v-btn
              icon
              color="white"
              small
              @click="$emit('dismiss')"
          >
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </div>
      </div>
      <v-divider></v-divider>
      <div class="px-2 pb-1" style="overflow-x: hidden; overflow-y: hidden">
        <v-text-field
            label="Employee Full Name"
            hide-details="auto"
            v-model="employee.fullName"
            @change="changesMade = true"
            :rules="[validationRules.required, validationRules.notNull]"
        />
        <v-text-field
            label="Employee ID No."
            hide-details="auto"
            v-model="employee.idNo"
            @change="changesMade = true"
            :rules="[validationRules.required, validationRules.notNull]"
        />
        <v-text-field
            label="Employee Code."
            hide-details="auto"
            v-model="employee.empCode"
            @change="changesMade = true"
            :rules="[validationRules.required, validationRules.notNull]"
        />
        <v-text-field
            label="Export ID"
            hide-details="auto"
            v-model="employee.exportID"
            @change="changesMade = true"
            :rules="[validationRules.required, validationRules.fourteenCharacters]"
        />
        <v-combobox
            label="Job Description"
            hide-details="auto"
            no-data-text="No available farms"
            v-model="employee.jobDesc"
            :items="$store.getters.jobDescriptionNames"
            @input="changesMade = true"
            clearable
            @click.clear="changesMade = true"
        />
        
        <v-autocomplete
            label="Farm"
            hide-details="auto"
            no-data-text="No available farms"
            v-model="employee.fkFarm"
            item-text="description"
            item-value="id"
            :items="disabledFarms"
            @input="changesMade = true"
            clearable
            @click.clear="changesMade = true"
        />
        
        <div class="overline grey--text" v-if="loadingJobs">
          Loading Bins . . .
        </div>
        <div class="overline green--text" v-else-if="!binsCount">
          No Bins For Today
        </div>
        <div class="overline error--text" v-else>
          {{ binsCount }} Bins Picked Today
        </div>
        
        
        <v-autocomplete
            v-if="!refsh && employee.id"
            label="Team"
            hide-details="auto"
            no-data-text="No available farms"
            v-model="employee.team"
            item-text="description"
            item-value="id"
            :items="teams"
            @input="$event === 'Create New Team' ? createTeamShow = true : changesMade = true;"
            clearable
            @click.clear="changesMade = true"
        />
        
        <v-dialog v-if="createTeamShow" v-model="createTeamShow" width="400">
          <v-card>
            <div class="d-flex align-center primary pl-3 pr-2">
              <div class="flex-grow-1 sub--text">
                Create Team
              </div>
              <v-btn
                  icon
                  color="white"
                  small
                  @click="createTeamShow = false"
              >
                <v-icon small>mdi-close</v-icon>
              </v-btn>
            </div>
            <v-divider></v-divider>
            <div class="px-2 pb-1" style="overflow-x: hidden; overflow-y: hidden">
              <v-text-field
                  label="Team Name"
                  placeholder="eg. Team 1"
                  hide-details="auto"
                  v-model="createTeamDescription"
                  :rules="[validationRules.required]"
              />
            </div>
            <v-divider></v-divider>
            <div class="d-flex justify-end pa-2">
              <v-btn
                  small
                  color="primary"
                  :disabled="!createTeamDescription"
                  @click="createTeamTemp"
              >Create Team
              </v-btn>
            </div>
          </v-card>
        
        </v-dialog>
        
        <v-switch
            v-if="editEmp.id"
            v-model="disabled"
            color="error"
            label="Disabled"
            hide-details
            @change="changesMade = true"
        >
        </v-switch>
        
        <v-autocomplete
            label="Employee Status"
            hide-details="auto"
            no-data-text="No employee statuses available"
            v-model="employee.fkStatus"
            :items="$store.state.empStatuses"
            item-value="id"
            item-text="name"
            @input="changesMade = true"
        />
        
        <v-autocomplete
            label="Employee Shift"
            hide-details="auto"
            no-data-text="No employee statuses available"
            v-model="employee.fkShift"
            :items="shifts"
            item-value="id"
            item-text="name"
            @input="changesMade = true"
        />
      
      
      </div>
      <div class="text-right pr-2 pt-2 pb-2">
        <v-btn
            @click="validateSave()"
            fab
            small
            color="secondary"
            :loading="loading"
            :disabled="!changesMade || loading"
        >
          <v-icon v-if="!loading">mdi-content-save</v-icon>
        </v-btn>
      </div>
    </div>
  </v-form>
</template>

<script>
import {mapGetters} from 'vuex'
import {validationRules} from "../../../core/codeFunctions";
import {waitForEvent} from "@/core/socket";

export default {
  components: {},
  props: {
    editEmp: Object
  },
  data() {
    return {
      employee: null,
      loading: false,
      validationRules: validationRules,
      changesMade: false,
      createTeamShow: false,
      createTeamDescription: null,
      refsh: false,
      loadingJobs: false,
      binsCount: 0
    }
  },
  watch: {
    editEmp: {
      deep: true,
      immediate: true,
      handler(val) {
        this.changesMade = false
        this.loadingJobs = false
        this.binsCount = 0
        console.log(val)
        this.employee = JSON.parse(JSON.stringify(val))
        if (val.id) {
          this.getJobsForToday()
        }
      }
    },
    createTeamShow(val) {
      if (!val)
        this.createTeamDescription = null;
    }
  },
  methods: {
    async getJobsForToday() {
      this.loadingJobs = true;
      try {
        const {binsCount} = await this.$newReq('GET', `setup/emp/jobsForToday/${this.employee.id}`)
        this.binsCount = binsCount
      } catch (e) {
        console.log(e)
        this.$snack.netWorkError()
      } finally {
        this.loadingJobs = false
      }
    },
    
    createTeamTemp() {
      this.employee.team = this.createTeamDescription;
      this.createTeamShow = false;
    },
    
    validateSave() {
      if (!this.$refs.modifyEmpForm.validate()) {
        console.log('NOT VALIDATED')
        return false
      }
      this.$emit('save', {emp: this.employee, ref: this})
    }
  },
  computed: {
    ...mapGetters(['emp', 'farms', 'availableFarms']),
    
    shifts() {
      return [
        {id: null, name: 'Not a shift worker'},
          ...this.$store.state.shifts
              .filter(v => !v.removed)
              .sort((a,b) => a.name.localeCompare(b.name))
      ]
    },
    
    disabled: {
      get() {
        return this.employee.disabled ? 1 : 0
      },
      set(val) {
        this.employee.disabled = val ? 1 : 0
        console.log(val, val ? 1 : 0, this.employee)
      }
    },
    
    disabledFarms() {
      const availableFarmsArr = this.availableFarms.map(obj => obj.id)
      return this.farms.map(farm => {
        return {
          ...farm,
          disabled: !availableFarmsArr.includes(farm.id)
        }
      })
    },
    
    teams() {
      const items = [
        "Create New Team",
        ...this.emp.reduce((list, emp) => {
          return !emp.team || list.includes(emp.team) ? list : list.concat(emp.team)
        }, [])
            .sort((a, b) => a > b ? 1 : -1)
      ]
      
      if (!items.includes(this.employee.team) && this.employee.team)
        items.push(this.employee.team)
      
      return items
    },
  },
}
</script>

<style scoped>

</style>